import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';
import Station from '../Station';

const defaults = {
    date: null,
    event: null,
    location: new Station(),
};

export default class STicketScan extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(STicketScan, json, {
            date: fields.datetime,
            event: fields.string,
            location: resolve.as(Station),
        });
    }
}
